import { parsePeopleSavedViews, type PeopleViewPreferencesPort } from '../../features/people/public';

export function createPeopleViewPreferencesAdapter(tenant: string, personId: string, readOnly: boolean): PeopleViewPreferencesPort {
  const key = `heyday.people.views.v1:${encodeURIComponent(tenant)}:${encodeURIComponent(personId)}`;
  return {
    read() {
      if (!tenant || !personId || readOnly) return [];
      try { return parsePeopleSavedViews(JSON.parse(localStorage.getItem(key) ?? '[]')); } catch { return []; }
    },
    write(views) {
      if (!tenant || !personId || readOnly) throw new Error('조회 조건을 저장할 수 없습니다.');
      localStorage.setItem(key, JSON.stringify(parsePeopleSavedViews(views)));
    },
  };
}
